import React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { Button, Image, Popup, Icon } from 'semantic-ui-react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { StripeForm } from './stripe-form';
import appSettings from '../app-settings.json';
import {
  // SectionContainer,
  HeaderWrapper,
  FieldLabel,
  FieldWrapper,
  ButtonContainer,
  ImageContainer,
  StyledAmountContent,
  StyledAmountWrapper,
} from '../components/tot-pay/tot-payment-styles';
import { covertNumberToCurrency } from '../utils/utility-functions';

const stripePromise = loadStripe(appSettings.stripePublishableKey);

const Flex = styled.div`
  display: flex;
  justify-content: space-evenly;
  width: 100%;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

const FieldItem = ({ label, content, accent, popupMessage }) => {
  const labelProps = accent ? { style: { fontWeight: '900' } } : {};
  const valueProps = accent ? { style: { fontWeight: '900', color: 'black' } } : {};

  return (
    <FieldWrapper>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <FieldLabel {...labelProps}>{label}</FieldLabel>
        {popupMessage &&
          <Popup
            content={popupMessage}
            trigger={<Icon style={{ marginTop: '-5px', marginLeft: '3px' }} name='info circle' />}
            inverted
          />
        }
      </div>
      <div {...valueProps}>{content}</div>
    </FieldWrapper>
  );
};



export function CheckoutForm({
  onSuccess,
  onSuccessRedirect,
  totalAmount,
  checkoutDetails,
  licenseFeeInfo,
  paymentPayload,
  setIsPaymentError,
  setActivePaymentMethodTab,
  activePaymentMethodTab,
  setPaymentErrorMessage,
}) {

  const history = useHistory();

  return (
    <Flex>
      <Column>
        <StyledAmountWrapper>
          <HeaderWrapper>Total Amount Due</HeaderWrapper>
          <StyledAmountContent>
            {covertNumberToCurrency(totalAmount)}
          </StyledAmountContent>
        </StyledAmountWrapper>
        {checkoutDetails.map((item) => (
          <FieldItem
            key={item.label}
            label={item.label}
            content={covertNumberToCurrency(item.value)}
          />
        ))}
        <ButtonContainer style={{ marginTop: 100 }}>
          <Button basic content="Back" onClick={() => history.goBack()} />
        </ButtonContainer>
      </Column>
      <Column style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Elements stripe={stripePromise}>
          <StripeForm
            onSuccess={onSuccess}
            onSuccessRedirect={onSuccessRedirect}
            licenseFeeInfo={licenseFeeInfo}
            paymentPayload={paymentPayload}
            setIsPaymentError={setIsPaymentError}
            setActivePaymentMethodTab={setActivePaymentMethodTab}
            activePaymentMethodTab={activePaymentMethodTab}
            setPaymentErrorMessage={setPaymentErrorMessage}
          />
        </Elements>
        <ImageContainer>
          <Image src="../../../assets/tot-pay-payment.svg" />
        </ImageContainer>
      </Column>
    </Flex>
  );
}
